import React from 'react';
import ServiceFrame from '../components/ServiceFrame';

/**
 * PatientPortal Page
 * Embeds the Patient Service UI (port 3100) using the same ServiceFrame logic as Claims, EOB, etc.
 * On domain: path-based /services/patients. On localhost/IP: port-based :3100.
 */
const PatientPortal = () => {
  return (
    <div className="h-full w-full">
      <ServiceFrame 
        serviceUrl={3100}
        serviceName="Patient Portal Management"
      />
    </div>
  );
};

export default PatientPortal;

